<template>
    <div>
        <control :label="'Head of Loss ' + (index + 1)">
            <input autocomplete="off" name="name"
                   placeholder="Type of Head of Loss"
                   @change="updateValid"
                   v-field-control
                   required
                   v-model="name">
            <control-error :show="$error('name') || !name ">
                Name of loss is required
            </control-error>
        </control>

        <control for="value" before-after="pound">
            <input autocomplete="off" name="value"
                   @change="updateValid"
                   v-field-control
                   required
                   v-on:focus="value = value || ''"
                   v-on:blur="value = value || 0"
                   min="1"
                   v-two-dp
                   type="number"
                   v-model="value">
            <control-error :show="$error('value')">
                Value should be greater than £0.00
            </control-error>

            <button class="a-button" @click="deleteThisHeadOfLoss">Delete Head of Loss</button>
        </control>
    </div>
</template>

<script>
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import FormValidator from 'components/form/validator/mixin';
    import {mapGetters, mapActions} from 'vuex';
    import { setStepValid }  from 'services/routingMethods';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';

    export default {
        name: 'headOfLoss',
        props: {
            index: {
                type: Number,
                required: true
            }
        },
        components: {
            Control,
            ControlError
        },
        mixins: [
            FormValidator
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        mounted() {
            this.$emit('update');
        },
        computed: {
            ...mapGetters('fatal/dependency/headsOfLoss', ['findHeadOfLoss']),
            name: {
                get(){
                    return this.findHeadOfLoss(this.index).name
                },
                set(value){
                    this.updateHeadOfLossValue({key: 'name', index: this.index, value});
                }
            },
            value: {
                get(){
                    return this.findHeadOfLoss(this.index).value
                },
                set(value){
                    this.updateHeadOfLossValue({key: 'value', index: this.index, value});
                }
            },
        },
        methods: {
            ...mapActions('fatal/dependency/headsOfLoss', [
                'updateHeadOfLossValue',
                'deleteHeadOfLoss'
            ]),
            deleteThisHeadOfLoss() {
                this.deleteHeadOfLoss(this.index);
                this.$emit('update');
            },
            updateValid() {
                this.$emit('update');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// HeadOfLoss.vue?4e8fc1fc